import React from "react";
import styled from "styled-components";

export const Layout = styled.div``;

const TitleWithBackContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-bottom: ${(props) => props?.mb ?? 20}px;
  @media screen and (max-width: 1024px) {
    & {
      height: 56px;
      padding: 0 18px;
      background: #ffffff;
      border-radius: 24px;
      margin-bottom: 20px;
    }
    &.mint{
      background-color: transparent;
      margin-bottom: 30px;
    }
  }
`;
const TitleWithBackWalletContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-bottom: ${(props) => props?.mb ?? 50}px;
  @media screen and (max-width: 1024px) {
    & {
      height: 56px;
      padding: 0 4px;
      border-radius: 24px;
      margin-bottom: 10px;
    }
  }
`;

export const TitlePage = styled.span`
  font-weight: 500;
  font-size: 25px;
  line-height: 30px;
  letter-spacing: -0.96px;
  color: #000000;
  @media (max-width: 1024px) {
    font-size: 20px;
    color: #000000;
  }
`;
export const TitleStake = styled.span`
  font-weight: 700;
  font-size: 48px;
  line-height: 56px;
  letter-spacing: -4%;
  color: #000000;
  @media (max-width: 1024px) {
    font-size: 30px;
    color: #000000;
  }
`;
export const TitleWithBackIcon = styled.div`
  display: flex;
  align-items: center;
  margin-right: 16px;
  @media screen and (max-width: 1024px) {
    & svg {
      height: 14px;
    }
  }
`;
const TitleWithBackText = styled.div`
  font-weight: 600;
  font-size: 34px;
  line-height: 150%;
  letter-spacing: -0.04em;
  text-transform: capitalize;
  color: #000000;
  @media screen and (max-width: 1024px) {
    & {
      font-size: 20px;
    }
  }
`;
export const TitleWithBack = (props) => {
  return (
    <TitleWithBackContainer mb={props?.mb} className={props?.className}>
      <TitleWithBackIcon onClick={props.onClick}>
        <svg
          width="13"
          height="20"
          viewBox="0 0 13 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.3439 2.3439L4.68723 10L12.3439 17.6561L9.99943 20L0 10L10 0L12.3439 2.3439Z"
            fill="#000000"
          />
        </svg>
      </TitleWithBackIcon>
      <TitleWithBackText onClick={props.onClick}>
        {props.title}
      </TitleWithBackText>
    </TitleWithBackContainer>
  );
};
export const TitleWithBackWallet = (props) => {
  return (
    <TitleWithBackWalletContainer mb={props?.mb} className={props?.className}>
      <TitleWithBackIcon onClick={props.onClick}>
        <svg
          width="13"
          height="20"
          viewBox="0 0 13 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.3439 2.3439L4.68723 10L12.3439 17.6561L9.99943 20L0 10L10 0L12.3439 2.3439Z"
            fill="#000000"
          />
        </svg>
      </TitleWithBackIcon>
      <TitleWithBackText onClick={props.onClick}>
        {props.title}
      </TitleWithBackText>
    </TitleWithBackWalletContainer>
  );
};
